import { useEffect, useState } from "react";
import Select from "react-select";
import axiosInstance from "../../../axiosInterceptor";

/* ---------- Checkbox Option ---------- */
const CheckboxOption = ({ data, innerRef, innerProps, selectProps }) => {
  const isSelected = selectProps.value?.some(
    (v) => v.value === data.value
  );

  return (
    <div
      ref={innerRef}
      {...innerProps}
      className="d-flex align-items-center gap-2 p-2"
      style={{ cursor: "pointer" }}
    >
      <input type="checkbox" checked={isSelected} readOnly />
      <span>{data.label}</span>
    </div>
  );
};

/* ---------- CMS Select ---------- */
const CMSSelect = ({
  endPoint,
  parentId,
  value = [],      // ✅ array of selected CMS
  onChange,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  /* Fetch CMS list */
  useEffect(() => {
    axiosInstance.get("/cms").then((res) => {
      setOptions(
        (res.data.data || []).map((item) => ({
          value: item.id,
          label: item.title,
        }))
      );
    });
  }, []);

  /* Toggle check / uncheck */
  const handleToggle = async (option) => {
    const exists = value.some((v) => v.value === option.value);

    const updatedValue = exists
      ? value.filter((v) => v.value !== option.value) // ❌ uncheck
      : [...value, option];                            // ✅ check

    try {
      setLoading(true);

      await axiosInstance.post(endPoint, {
        id: parentId,
        cms_id: option.value,
        action: exists ? "REMOVE" : "ADD", 
      });

      onChange?.(updatedValue);
    } catch (error) {
      return error
    } finally {
      setLoading(false);
    }
  };

  return (
    <Select
      isMulti
      options={options}
      value={value}
      isLoading={loading}
      placeholder="Select CMS"
      closeMenuOnSelect={false}
      hideSelectedOptions={false}

      /* 🔑 Important */
      controlShouldRenderValue={false} // hide values in input
      components={{ Option: CheckboxOption }}

      /* Manual toggle */
      onChange={(selected, meta) => {
        if (meta?.option) {
          handleToggle(meta.option);
        }
      }}

      styles={{
        control: (base) => ({
          ...base,
          minWidth: 350,
          minHeight: 48,
          borderRadius: 8,
        }),
      }}
    />
  );
};

export default CMSSelect;
